// #232: a Central deixou de ser só folha sobreposta no mobile — ela tem rota
// própria. O caminho vive aqui (e não no routes.partial) para que a bottom-nav
// e a folha possam se coordenar sem importar o módulo de rotas.
import { withConquestsAreaSearchParams } from "./conquests-url";
import type { ConquestsArea } from "./types";

export const CONQUESTS_ROUTE_PATH = "/conquistas";

/** Endereço canônico da Central já apontando para uma área.
 * @example `conquestsRoutePath("compete")` → `/conquistas?conquistas=competir` */
export function conquestsRoutePath(area: ConquestsArea): string {
  const params = withConquestsAreaSearchParams(new URLSearchParams(), area);
  return `${CONQUESTS_ROUTE_PATH}?${params.toString()}`;
}

/** A folha nunca pode montar sobre a página — as duas leem a mesma query.
 * @example `isConquestsRoutePathname("/conquistas")` */
export function isConquestsRoutePathname(pathname: string): boolean {
  return pathname === CONQUESTS_ROUTE_PATH;
}
